var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useDebounce } from 'use-debounce';
import toast from 'react-hot-toast';
import numbro from 'numbro';
import { WidgetType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import { createDraggableId, createDroppableId, DraggableType, DroppableType, getDraggableTagType, SingleValueZone, } from '@data/dragAndDrop/types';
import WidgetMenu from '@main/dashboard/WidgetMenu';
import WidgetLoader from '@main/dashboard/WidgetLoader';
import WidgetParentChangeModal from '@main/dashboard/WidgetParentChangeModal';
import FSButton from '@components/FSButton';
import Tag from '@shared/tags/Tag';
import Manager from '@shared/modal/Manager';
import { ChevronDown, ChevronUp, Copy, Delete, Edit, Select, Tag as TagIcon } from '@shared/icons/icons';
import { cellsApi } from '@data/rest/api';
import { useTagContext } from '@data/tag/tagContext';
import { useAuth } from '../../../providers/AuthProvider';
import { useSingleValueData } from '@data/hooks/singleValueData';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useCloneWidget, useDeleteWidget, useUpdateWidget } from '@data/widgets/widgetActions';
import { formatNumber } from '@util/formatNum';
import { SingleValueComparisonData, SingleValueComparisonNumber, SingleValueData, SingleValueDataInput, SingleValueDataInputButtonContainer, SingleValueDataInputContainer, TagDropzone, TagDropzoneGrid, TagDropzonePlaceholder, WidgetBox, WidgetContent, WidgetTitle, } from '@styled/Widget';
import SingleValueEditor from './SingleValueEditor';
function SingleValueTagDropzone(_a) {
    var tags = _a.tags, zone = _a.zone, widgetId = _a.widgetId, showTags = _a.showTags, draggingOver = _a.draggingOver, setDraggingOver = _a.setDraggingOver, removeTag = _a.removeTag, rowSpan = _a.rowSpan, colSpan = _a.colSpan;
    var droppableId = createDroppableId({ type: DroppableType.SingleValueWidget, widgetId: widgetId, zone: zone });
    return (React.createElement(Droppable, { droppableId: droppableId }, function (provided, snapshot) {
        useEffect(function () {
            if (draggingOver !== zone && snapshot.isDraggingOver) {
                // set draggingOver to this zone if not already set
                setDraggingOver(zone);
            }
            else if (draggingOver === zone && !snapshot.isDraggingOver) {
                // set draggingOver to null when leaving this zone
                setDraggingOver(null);
            }
        }, [draggingOver, setDraggingOver, snapshot, zone]);
        return (React.createElement(TagDropzone, __assign({ ref: provided.innerRef }, provided.droppableProps, { "$hovered": showTags || draggingOver === null || draggingOver === zone, "$selected": false, "$rowSpan": rowSpan, "$colSpan": colSpan }), tags.length > 0 ? (tags.map(function (tag, tagIndex) {
            var draggableId = createDraggableId({
                type: DraggableType.Tag,
                tagId: tag.id,
                tagType: getDraggableTagType(tag.type),
                sourceDroppableId: droppableId,
            });
            return (React.createElement(Draggable, { key: draggableId, draggableId: draggableId, index: tagIndex }, function (draggableProvided, draggableSnapshot) {
                var tagComponent = (React.createElement("div", __assign({ ref: draggableProvided.innerRef }, draggableProvided.draggableProps, draggableProvided.dragHandleProps),
                    React.createElement(Tag, { tag: tag, canUpdate: true, onDelete: function () { return removeTag(tag.id, zone); } })));
                if (draggableSnapshot.isDragging) {
                    return createPortal(tagComponent, document.getElementById('portal'));
                }
                else {
                    return tagComponent;
                }
            }));
        })) : (React.createElement(TagDropzonePlaceholder, null, zone))));
    }));
}
export default function SingleValue(_a) {
    var _this = this;
    var _b, _c;
    var gridId = _a.gridId, widget = _a.widget, documentActions = _a.documentActions, reloadGridData = _a.reloadGridData, tagSlicersData = _a.tagSlicersData;
    var _d = useLanguage(), L = _d.L, excelLocalizedNumberFormat = _d.excelLocalizedNumberFormat;
    var user = useAuth().user;
    var wrapperRef = useRef(null);
    var updateWidget = useUpdateWidget();
    var deleteWidget = useDeleteWidget();
    var cloneWidget = useCloneWidget();
    var _e = __read(useState(false), 2), showTags = _e[0], setShowTags = _e[1];
    var _f = __read(useState(null), 2), draggingOver = _f[0], setDraggingOver = _f[1];
    var _g = __read(useDebounce(draggingOver, 50), 1), draggingOverDebounced = _g[0];
    var widgetConfig = useMemo(function () { return parseWidgetConfig(widget.config, WidgetType.SINGLEVALUE); }, [widget.config]);
    var tagData = useTagContext().tagData;
    var _h = __read(useState(0), 2), resetValueTrigger = _h[0], setResetValueTrigger = _h[1];
    var _j = __read(useSingleValueData(widgetConfig, widget.id, tagSlicersData.activeTagIds), 2), singleValue = _j[0], comparisonValue = _j[1];
    var _k = __read(useState(''), 2), singleValueAsString = _k[0], setSingleValueAsString = _k[1];
    var accountTagObjects = widgetConfig.accountTags
        .map(function (tagId) { return tagData.tagById[tagId]; })
        .filter(function (t) { return t !== undefined; });
    var filterTagObjects = widgetConfig.filterTags
        .map(function (tagId) { return tagData.tagById[tagId]; })
        .filter(function (t) { return t !== undefined; });
    var comparisonTagObjects = widgetConfig.comparisonTags
        .map(function (tagId) { return tagData.tagById[tagId]; })
        .filter(function (t) { return t !== undefined; });
    var accountTagFormat = (_c = (_b = accountTagObjects[0]) === null || _b === void 0 ? void 0 : _b.numberFormat) === null || _c === void 0 ? void 0 : _c.format;
    useEffect(function () {
        var stringValue = '';
        if (Number.isFinite(singleValue) && !Number.isNaN(singleValue)) {
            if (accountTagFormat !== undefined) {
                stringValue = excelLocalizedNumberFormat(singleValue, accountTagFormat);
            }
            else {
                stringValue = formatNumber(singleValue, widgetConfig.numformat);
            }
        }
        setSingleValueAsString(stringValue);
    }, [singleValue, accountTagFormat, widgetConfig.numformat, resetValueTrigger]);
    var comparisonValueAsString = useMemo(function () {
        var stringValue = '';
        if (singleValue !== null &&
            comparisonValue !== null &&
            !Number.isNaN(singleValue) &&
            !Number.isNaN(comparisonValue)) {
            var diff = singleValue - comparisonValue;
            var diffPercent = (diff / comparisonValue) * 100;
            stringValue = "".concat(diff >= 0 ? '+' : '').concat(accountTagFormat
                ? excelLocalizedNumberFormat(diff, accountTagFormat)
                : formatNumber(diff, widgetConfig.numformat), " (").concat(numbro(diffPercent).format({ mantissa: 1 }), "%)");
        }
        return stringValue;
    }, [singleValue, comparisonValue]);
    var dataEntryStep = useMemo(function () {
        var hasPercentSign = widgetConfig.dataEntryButtonStep.trim().endsWith('%');
        var numberValue = numbro.unformat(widgetConfig.dataEntryButtonStep.replace(/\%$/g, ''));
        if (numberValue === undefined) {
            return { type: 'error', number: 0 };
        }
        else if (hasPercentSign) {
            return { type: 'relative', number: numberValue / 100 };
        }
        else {
            return { type: 'absolute', number: numberValue };
        }
    }, [widgetConfig.dataEntryButtonStep]);
    function resetValue() {
        setResetValueTrigger(resetValueTrigger + 1);
    }
    function saveNumberValue(numberValue) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, cellsApi.updateBatch([
                            {
                                value: numberValue,
                                tagIds: __spreadArray(__spreadArray([], __read(widgetConfig.accountTags), false), __read(widgetConfig.filterTags), false),
                            },
                        ])];
                    case 1:
                        _a.sent();
                        reloadGridData();
                        return [2 /*return*/];
                }
            });
        });
    }
    function parseAndSaveValue() {
        return __awaiter(this, void 0, void 0, function () {
            var numberValue, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        numberValue = numbro.unformat(singleValueAsString);
                        if (!(numberValue === undefined)) return [3 /*break*/, 1];
                        toast.error(L('Error parsing input number'));
                        return [3 /*break*/, 4];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, saveNumberValue(numberValue)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        toast.error(L('Error saving data'));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function stepChangeValue(direction) {
        return __awaiter(this, void 0, void 0, function () {
            var newValue, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!widgetConfig.dataEntry) {
                            toast.error(L('Data entry not allowed'));
                            return [2 /*return*/];
                        }
                        if (dataEntryStep.type === 'error') {
                            toast.error(L('Error parsing step value'));
                            return [2 /*return*/];
                        }
                        newValue = singleValue !== null && singleValue !== void 0 ? singleValue : 0;
                        if (dataEntryStep.type === 'absolute') {
                            if (direction === 'up') {
                                newValue += dataEntryStep.number;
                            }
                            else if (direction === 'down') {
                                newValue -= dataEntryStep.number;
                            }
                        }
                        else if (dataEntryStep.type === 'relative') {
                            if (direction === 'up') {
                                newValue += dataEntryStep.number * newValue;
                            }
                            else if (direction === 'down') {
                                newValue -= dataEntryStep.number * newValue;
                            }
                        }
                        if (!(newValue !== singleValue)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, saveNumberValue(newValue)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        toast.error(L('Error saving data'));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function removeTag(tagId, zone) {
        var field = null;
        if (zone === SingleValueZone.Variable) {
            field = 'accountTags';
        }
        else if (zone === SingleValueZone.Filter) {
            field = 'filterTags';
        }
        else if (zone === SingleValueZone.Comparison) {
            field = 'comparisonTags';
        }
        if (field !== null) {
            var widgetConfigCopy = __assign({}, widgetConfig);
            widgetConfigCopy[field] = widgetConfigCopy[field].filter(function (tId) { return tId !== tagId; });
            updateWidget.mutate(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfigCopy) }));
        }
    }
    var widgetMenuItems = [
        {
            icon: Edit,
            actionName: L('Edit Tile'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () { return Manager.renderModal(React.createElement(SingleValueEditor, { widget: widget, gridId: gridId })); },
        },
        {
            icon: TagIcon,
            actionName: showTags ? L('Show Value') : L('Show Variables and Dimensions'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () {
                setShowTags(!showTags);
            },
        },
        {
            icon: Copy,
            actionName: L('Duplicate'),
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canDuplicate),
            action: function () { return cloneWidget.mutate(widget); },
        },
        {
            icon: Select,
            actionName: L('Move to'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () { return Manager.renderModal(React.createElement(WidgetParentChangeModal, { widget: widget, gridId: gridId })); },
        },
        { spacer: true },
        {
            icon: Delete,
            actionName: L('Delete Tile'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canDelete),
            action: function () { return deleteWidget.mutate(widget.id); },
            destructive: true,
        },
    ];
    var widgetTitle = widget.title && widget.title !== ''
        ? widget.title
        : filterTagObjects.length > 0
            ? "".concat(accountTagObjects.map(function (t) { return t.name; }).join(', '), " - ").concat(filterTagObjects.map(function (t) { return t.name; }).join(', '))
            : accountTagObjects.map(function (t) { return t.name; }).join(', ');
    return (React.createElement(React.Fragment, null,
        React.createElement(WidgetBox, { ref: wrapperRef },
            React.createElement(WidgetTitle, null, widgetTitle),
            React.createElement(WidgetMenu, { wrapperRef: wrapperRef, menuItems: widgetMenuItems }),
            React.createElement(WidgetContent, { "$overflow": showTags || draggingOverDebounced !== null ? 'visible' : 'hidden', onMouseDown: function (e) { return (showTags ? e.stopPropagation() : null); } },
                React.createElement(TagDropzoneGrid, { "$visible": showTags || draggingOverDebounced !== null, "$rowNumber": 2, "$columnNumber": 2 },
                    React.createElement(SingleValueTagDropzone, { tags: accountTagObjects, zone: SingleValueZone.Variable, widgetId: widget.id, showTags: showTags, draggingOver: draggingOver, setDraggingOver: setDraggingOver, removeTag: removeTag, colSpan: 2 }),
                    React.createElement(SingleValueTagDropzone, { tags: filterTagObjects, zone: SingleValueZone.Filter, widgetId: widget.id, showTags: showTags, draggingOver: draggingOver, setDraggingOver: setDraggingOver, removeTag: removeTag }),
                    React.createElement(SingleValueTagDropzone, { tags: comparisonTagObjects, zone: SingleValueZone.Comparison, widgetId: widget.id, showTags: showTags, draggingOver: draggingOver, setDraggingOver: setDraggingOver, removeTag: removeTag })),
                React.createElement("div", { style: {
                        visibility: !showTags && draggingOverDebounced === null ? 'visible' : 'hidden',
                        overflow: 'auto',
                        height: '100%',
                    } },
                    widgetConfig.dataEntry ? (React.createElement(SingleValueDataInputContainer, { onMouseDown: function (e) { return e.stopPropagation(); } },
                        React.createElement(SingleValueDataInput, { value: singleValueAsString, onChange: function (e) { return setSingleValueAsString(e.target.value); }, onKeyPress: function (e) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (e.key !== 'Enter') {
                                                return [2 /*return*/];
                                            }
                                            // save new value on enter press
                                            return [4 /*yield*/, parseAndSaveValue()];
                                        case 1:
                                            // save new value on enter press
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, onBlur: function () { return resetValue(); } }),
                        widgetConfig.showDataEntryButtons && (React.createElement(SingleValueDataInputButtonContainer, null,
                            React.createElement(FSButton, { icon: React.createElement(ChevronUp, { height: 28, width: 28 }), "$type": "tertiary", "$color": "neutral", onClick: function () { return stepChangeValue('up'); }, style: { height: 28 } }),
                            React.createElement(FSButton, { icon: React.createElement(ChevronDown, { height: 28, width: 28 }), "$type": "tertiary", "$color": "neutral", onClick: function () { return stepChangeValue('down'); }, style: { height: 28 } }))))) : (React.createElement(SingleValueData, null, singleValueAsString)),
                    comparisonTagObjects.length > 0 && singleValue !== null && comparisonValue !== null && (React.createElement(SingleValueComparisonData, null,
                        React.createElement("span", null,
                            React.createElement(SingleValueComparisonNumber, { "$positive": comparisonValueAsString.startsWith('+') }, comparisonValueAsString),
                            React.createElement("span", null, widgetConfig.comparisonCustomText !== ''
                                ? " ".concat(widgetConfig.comparisonCustomText)
                                : " vs. ".concat(comparisonTagObjects.map(function (t) { return t.name; }).join(', '))))))))),
        React.createElement(WidgetLoader, { wId: widget.id })));
}
